<div class="container-centred">
    <img imgPath="/flyfreely-logo-white.png" />
</div>
